import './BibleQuote.css';

interface IBibleQuoteProps {
  className?: string;
  quote: string
  source: string
}

const BibleQuote = (props: IBibleQuoteProps) => {
  return (
    <div
      className={
        'BibleQuote p-8' + (props.className ? (' ' + props.className) : '')
      }
    >
      <p className="text-3xl text-shadow color-black">"{props.quote}"</p>
      <p className="text-2xl pt-4">- {props.source}</p>
    </div>
  )
}

export default BibleQuote;